import { LinkedRecordTypeDefinition } from "../domain/LinkedRecordTypeDefinition";
import { SearchDialog } from "@ofqual/portal-components/components/SearchField/SearchDialog";
import React from "react";

import { useLookupService } from "../hooks/useLookupService";
import { useDispatch } from "react-redux";
import { createLinkedRecord } from "../redux/actions";
import { LinkedRecordsProps } from "./LinkedRecordsProps";

type AddLinkedRecordDialogProps = LinkedRecordsProps & {
  definition: LinkedRecordTypeDefinition;
  onClose: () => void;
};

export const AddLinkedRecordDialog: React.FC<AddLinkedRecordDialogProps> = ({
  entityReferenceId,
  entityLinkedRecordType,
  entityTitle,
  definition,
  onClose,
}) => {
  const dispatch = useDispatch();
  const service = useLookupService(definition, entityReferenceId);

  const onSelect = (val?: { id: any; label: string; [key: string]: any }) => {
    if (val) {
      console.log(val);
      dispatch(
        createLinkedRecord(entityReferenceId, {
          sourceType: entityLinkedRecordType,
          sourceTitle: entityTitle,
          destinationId: val.id,
          destinationType: definition.type,
          destinationTitle: val.label,
          linkType: 0,
          linkNote: "",
          linkMeta: !!definition.metadataCreator
            ? JSON.stringify(definition.metadataCreator(val))
            : "",
        })
      );
    }

    onClose();
  };

  return (
    <SearchDialog
      label={definition.label}
      dialogOpenProps={{ isDialogOpen: true, initialSearchText: "" }}
      onSelectOrClose={onSelect}
      service={service}
    />
  );
};
